import React from "react";
import { Snackbar, Alert, SnackbarProps, AlertColor } from "@mui/material";

interface CommonSnackbarProps {
  open: boolean;
  message: string;
  severity?: AlertColor;
  onClose: (event?: React.SyntheticEvent | Event, reason?: string) => void;
  autoHideDuration?: number;
  anchorOrigin?: SnackbarProps["anchorOrigin"];
}

const CommonSnackbar: React.FC<CommonSnackbarProps> = ({
  open,
  message,
  severity = "success",
  onClose,
  autoHideDuration = 4000,
  anchorOrigin = { vertical: "bottom", horizontal: "left" },
}) => (
  <Snackbar
    open={open}
    autoHideDuration={autoHideDuration}
    onClose={onClose}
    anchorOrigin={anchorOrigin}
  >
    <Alert onClose={onClose} severity={severity} sx={{ width: "100%" }}>
      {message}
    </Alert>
  </Snackbar>
);

export default CommonSnackbar;
